import React from "react";
import { WithContext as ReactTags } from "react-tag-input";

const TagInput = ({ tags, handleAddition, handleDelete, label, error }) => {
  return (
    <div className="mb-4">
      {label && (
        <label className="block mb-2 text-sm font-bold text-gray-700">
          {label}
        </label>
      )}
      <ReactTags
        tags={tags}
        handleDelete={handleDelete}
        handleAddition={handleAddition}
        inputFieldPosition="bottom"
        autocomplete
        classNames={{
          tagInput: "w-full",
          tagInputField:
            "w-full px-3 py-2 text-gray-700 border rounded-lg focus:outline-none focus:shadow-outline border-gray-300",
          tag: "bg-blue-100 text-blue-800 text-sm font-medium mr-2 px-2.5 py-0.5 rounded",
          remove: "ml-2 cursor-pointer text-blue-800",
        }}
      />
      {error && <p className="mt-1 text-xs italic text-red-500">{error}</p>}
    </div>
  );
};

export default TagInput;
